import {
  Component,
  ComponentFactoryResolver,
  Inject,
  Injector,
  OnInit,
  ViewChild,
  ViewContainerRef
} from "@angular/core";
import { POPUP_INJECT } from "../../../../../services/popup/popup-ref";
import { PopupComponent } from "../../../../../services/popup/popup-component";
import { Subject } from "rxjs";

export interface ImageViewerLoaderPopupData {
  src: string;
}

@Component({
  selector: "pms-image-viewer-loader",
  templateUrl: "image-viewer-loader.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ImageViewerLoaderComponent implements OnInit, PopupComponent {
  @ViewChild("imageViewerContainer", { read: ViewContainerRef })
  imageViewerContainer!: ViewContainerRef;

  loading: boolean = false;
  error: boolean = false;

  constructor(
    private injector: Injector,
    private componentFactoryResolver: ComponentFactoryResolver,
    @Inject(POPUP_INJECT.DATA) private data: ImageViewerLoaderPopupData
  ) {}

  isTitleVisible(): boolean {
    return false;
  }
  getTitle(): string {
    return "";
  }
  getSubtitle(): string {
    return "";
  }
  title$?: Subject<string> | undefined;

  ngOnInit(): void {
    this.loading = true;
    this.error = false;
  }

  async ngAfterViewInit(): Promise<void> {
    await this.load();
  }

  private async load(): Promise<void> {
    try {
      const { ImageViewerImplComponent } =
        await import("../image-viewer-impl/image-viewer-impl.component");

      const imageViewerImplComponentComponentFactory =
        this.componentFactoryResolver.resolveComponentFactory(
          ImageViewerImplComponent
        );

      const imageViewerComponent = this.imageViewerContainer.createComponent(
        imageViewerImplComponentComponentFactory
      );

      imageViewerComponent.instance.src = this.data.src;
    } catch (ex) {
      console.error(ex);
      this.error = false;
    } finally {
      this.loading = false;
    }
  }
}
